<template>
    <div class="page-subnavigation">
        <div
            v-for="(item, index) in visibleItems"
            :key="index"
            class="page-subnavigation__item"
            :class="{ active: item.activePath !== undefined ? isRoutePathActive(item.activePath) : item.isActive, 'page-subnavigation__item--main': index === 0 }"
            @click="toggleAccordion(index)"
        >
            <div class="page-subnavigation__item__main">
                <router-link class="page-subnavigation__item__link" :to="item.to">
                    <span v-if="item.icon" class="page-subnavigation__item__icon">
                        <i class="icon" :class="`icon--${item.icon}`"></i>
                    </span>
                    <div class="page-subnavigation__item__label">{{ item.label }}</div>
                </router-link>
                <div v-if="activeLink && index === 0 && activeLink.label !== visibleItems[0].label" class="page-subnavigation__item__active-info">
                    <i class="icon icon--common-caret"></i>
                    <div class="page-subnavigation__item__label">{{ activeLink.label }}</div>
                </div>
            </div>
            <div v-if="index === 0">
                <i class="icon icon--common-caret page-subnavigation__indicator" :class="{ 'page-subnavigation__indicator--rotate': !open }"></i>
            </div>
        </div>
    </div>
</template>

<script>
import routePathActive from '@/mixins/routePathActive';

export default {
    mixins: [routePathActive],
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            open: false,
        };
    },
    mounted() {
        console.log(this.$route);
    },
    computed: {
        visibleItems() {
            if (!this.open) return this.items.slice(0, 1);
            return this.items;
        },
        activeLink() {
            return this.items.find(item => item.to.name === this.$route.name);
        },
    },
    methods: {
        toggleAccordion(index) {
            if (index !== 0) return;
            this.open = !this.open;
        },
    },
};
</script>

<style lang="scss">
.page-subnavigation {
    $block: &;
    background: $color-gray-dark;
    color: white;

    @include mq(wrapper) {
        display: none;
    }

    &__indicator {
        font-size: 8px;
        padding: 12px;

        &--rotate {
            transform: rotate(180deg);
        }
    }

    &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &:not(:last-child) {
            border-bottom: 1px solid $color-gray;
        }

        &--main {
            background: $color-gray;
            border: none;
            cursor: pointer;

            #{$block}__item {
                &__link {
                    padding-left: 12px;
                    flex-grow: unset;
                    max-width: 50%;

                    &:only-child {
                        max-width: 100%;
                    }
                }
                &__active-info {
                    max-width: 50%;
                }
            }
        }

        &__main {
            display: flex;
            align-items: center;
            line-height: 1;
            gap: 6px;
            max-width: 90%;
            flex-grow: 1;
        }

        &__link {
            display: flex;
            align-items: center;
            gap: 8px;
            color: white;
            flex-grow: 1;
            padding: 12px;
            padding-left: 12px + 20px + 8px;
            padding-right: 0;
            font-weight: 400;

            .active & {
                color: $color-accent;
            }
        }

        &__active-info {
            display: flex;
            align-items: center;
            gap: 6px;
            color: $color-accent;
            font-weight: 400;
            .icon {
                transform: rotate(90deg);
                font-size: 5px;
            }
        }

        &__icon {
            font-size: 18px;
            width: 20px;
        }

        &__label {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.2;
        }
    }
}
</style>
